import { ActionIcon, Box, Textarea } from "@mantine/core";
import { useInputState } from "@mantine/hooks";
import { IconPlayerPlay } from "@tabler/icons-react";
import type { JSX, KeyboardEvent, MouseEvent } from "react";

import classes from "./ChatInput.module.css";

interface IProps {
    askAi: (content: string) => Promise<void>;
}

function ChatInput({ askAi }: IProps): JSX.Element {
    const [value, handleChange] = useInputState("");

    const handleOnKeyDown = (event: KeyboardEvent) => {
        if (!value) {
            return;
        }
        if (event.key === "Enter" && !event.shiftKey) {
            askAi(value);
            handleChange("");
            event.preventDefault();
        }
    };

    const handleClick = (_event: MouseEvent<HTMLButtonElement>) => {
        if (!value) {
            return;
        }
        askAi(value);
        handleChange("");
    };

    return (
        <Box className={classes.box}>
            <Textarea
                placeholder="Ask the AI"
                autosize
                value={value}
                onChange={handleChange}
                onKeyDown={handleOnKeyDown}
                styles={{
                    input: {
                        paddingRight: 38,
                    },
                }}
            />
            <ActionIcon className={classes.button} size={36} onClick={handleClick}>
                <IconPlayerPlay />
            </ActionIcon>
        </Box>
    );
}

export default ChatInput;
